module.exports = __webpack_public_path__ + "static/sport/in4.8072a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ldp/in4.jpg
// module id = E2LL
// module chunks = 0